import { render, staticRenderFns } from "./TopicsReviewStatusAdd.vue?vue&type=template&id=d70d2a38&"
import script from "./TopicsReviewStatusAdd.vue?vue&type=script&lang=js&"
export * from "./TopicsReviewStatusAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports